import { render } from "./ArticleDetail.vue?vue&type=template&id=c1b2499a&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"

import "./ArticleDetail.vue?vue&type=style&index=0&id=c1b2499a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b2499a"]])

export default __exports__